'use client';
import * as Icons from '@mui/icons-material';
import dynamic from 'next/dynamic';
import style from './style.module.css';

type StatusType = 'success' | 'warning' | 'info';

export interface InfoDescribedProps {
  iconName: string;
  title: string;
  description?: string;
  status?: StatusType;
}

const iconsMap = {};

const InfoDescribed: React.FC<InfoDescribedProps> = ({
  iconName,
  title,
  description,
  status = 'info',
}) => {
  let IconComponent = iconsMap[iconName];

  if (!iconsMap[iconName]) {
    IconComponent = dynamic(() =>
      import('@mui/icons-material').then(
        (icons) => icons[iconName as keyof typeof Icons]
      )
    );
    iconsMap[iconName] = IconComponent;
  }

  const textColorClass = style[`text--${status}`];

  return (
    <div className={style.card}>
      <div className={`${style.icon} ${textColorClass}`}>
        <IconComponent key={iconName} />
      </div>
      <div className={style.content}>
        <h3 className={`${style.title} ${textColorClass}`} aria-hidden="true">
          {title}
        </h3>
        {description && (
          <p
            className={`${style.description} ${textColorClass}`}
            aria-hidden="true">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default InfoDescribed;
